module.exports = __webpack_public_path__ + "img/00028.f1d7929d.webp";